import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { MultiStepStepProps } from 'components/MultiStepFlow/Types'
import { DesktopInstructions } from 'flows/common/steps/BrandKitInstructions/DesktopInstructions'

export const BrandKitInstructions = ({ onBack, onNext }: MultiStepStepProps) => {
  return (
    <MultiStepStepLayout onBack={onBack} onNext={onNext} analyticsId="brandkit-instructions">
      <DesktopInstructions />
    </MultiStepStepLayout>
  )
}
